<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AlCA2l/images/e9781439633618_cover.jpg?1688985070673" alt="This image is the cover for the book Lowndes County, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lowndes County, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>Lowndes County, located deep in the wiregrass region of southern Georgia, has been continuously occupied since ancient times. Through the centuries, various Native American tribes inhabited the region, but they lingered relatively briefly and left few tangible traces. The area�s written history began with the establishment around 1623 of the Spanish mission of Santa Cruz de Cachipile in southern Lowndes. Georgia�s general assembly created Lowndes County from the southern half of Irwin County in 1825 and named it for William Jones Lowndes of South Carolina. The present county seat, Valdosta, dates from the construction of the Atlantic and Gulf Railroad across Lowndes from 1859 to 1860. Ultimately the county was to have five railroads, which, combined with U.S. Highways 41 and 84 and Interstate 75, were to be major factors in dramatic local growth."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Dr. Joseph A. Tomberlin, 
      </h2>
      
      <p class="authorDescription body article">This volume features pictures primarily from the collections of the Lowndes County Historical Society that illustrate significant aspects of the area�s daily life. They have been selected and assembled by Dr. Joseph A. Tomberlin, professor emeritus of history at Valdosta State University and longtime head of the university�s Department of History. Dr. Tomberlin has lived in Valdosta since the age of 12 and has had both personal and professional interest in the history of the area for many years.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01e4ac45